/**
 * India States and Union Territories — controlled list (28 States + 8 UTs).
 * Codes follow ISO 3166-2:IN. State/UT for Indian addresses must be chosen from this list;
 * free text is not accepted by the API.
 */
export type RegionType = 'STATE' | 'UNION_TERRITORY';

export interface IndiaRegion {
  code: string;
  name: string;
  type: RegionType;
}

export const INDIA_STATES_AND_UTS: readonly IndiaRegion[] = [
  { code: 'AP', name: 'Andhra Pradesh', type: 'STATE' },
  { code: 'AR', name: 'Arunachal Pradesh', type: 'STATE' },
  { code: 'AS', name: 'Assam', type: 'STATE' },
  { code: 'BR', name: 'Bihar', type: 'STATE' },
  { code: 'CT', name: 'Chhattisgarh', type: 'STATE' },
  { code: 'GA', name: 'Goa', type: 'STATE' },
  { code: 'GJ', name: 'Gujarat', type: 'STATE' },
  { code: 'HR', name: 'Haryana', type: 'STATE' },
  { code: 'HP', name: 'Himachal Pradesh', type: 'STATE' },
  { code: 'JH', name: 'Jharkhand', type: 'STATE' },
  { code: 'KA', name: 'Karnataka', type: 'STATE' },
  { code: 'KL', name: 'Kerala', type: 'STATE' },
  { code: 'MP', name: 'Madhya Pradesh', type: 'STATE' },
  { code: 'MH', name: 'Maharashtra', type: 'STATE' },
  { code: 'MN', name: 'Manipur', type: 'STATE' },
  { code: 'ML', name: 'Meghalaya', type: 'STATE' },
  { code: 'MZ', name: 'Mizoram', type: 'STATE' },
  { code: 'NL', name: 'Nagaland', type: 'STATE' },
  { code: 'OR', name: 'Odisha', type: 'STATE' },
  { code: 'PB', name: 'Punjab', type: 'STATE' },
  { code: 'RJ', name: 'Rajasthan', type: 'STATE' },
  { code: 'SK', name: 'Sikkim', type: 'STATE' },
  { code: 'TN', name: 'Tamil Nadu', type: 'STATE' },
  { code: 'TG', name: 'Telangana', type: 'STATE' },
  { code: 'TR', name: 'Tripura', type: 'STATE' },
  { code: 'UP', name: 'Uttar Pradesh', type: 'STATE' },
  { code: 'UT', name: 'Uttarakhand', type: 'STATE' },
  { code: 'WB', name: 'West Bengal', type: 'STATE' },
  { code: 'AN', name: 'Andaman and Nicobar Islands', type: 'UNION_TERRITORY' },
  { code: 'CH', name: 'Chandigarh', type: 'UNION_TERRITORY' },
  { code: 'DH', name: 'Dadra and Nagar Haveli and Daman and Diu', type: 'UNION_TERRITORY' },
  { code: 'DL', name: 'Delhi', type: 'UNION_TERRITORY' },
  { code: 'JK', name: 'Jammu and Kashmir', type: 'UNION_TERRITORY' },
  { code: 'LA', name: 'Ladakh', type: 'UNION_TERRITORY' },
  { code: 'LD', name: 'Lakshadweep', type: 'UNION_TERRITORY' },
  { code: 'PY', name: 'Puducherry', type: 'UNION_TERRITORY' },
];

export const INDIA_REGION_CODES = INDIA_STATES_AND_UTS.map((r) => r.code);

/** Indian PIN code: 6 digits, first digit 1-9. */
export const INDIA_PIN_CODE_REGEX = /^[1-9][0-9]{5}$/;

/** Indian mobile: optional +91 / 0 prefix then 10 digits starting 6-9. */
export const INDIA_MOBILE_REGEX = /^(?:\+91[\s-]?|0)?[6-9]\d{9}$/;

/** Time zones commonly needed for Indian SMEs (IANA). India itself uses a single zone. */
export const SUPPORTED_TIMEZONES = [
  'Asia/Kolkata',
  'Asia/Dubai',
  'Asia/Singapore',
  'Europe/London',
  'America/New_York',
  'America/Los_Angeles',
  'UTC',
] as const;

export const INDIA_DATE_FORMAT = 'DD/MM/YYYY';
export const DEFAULT_CURRENCY = 'INR';
export const DEFAULT_LOCALE = 'en-IN';
export const DEFAULT_TIMEZONE = 'Asia/Kolkata';
